import { useCallback, useContext } from 'react';
import { MessageContext } from '../../../contexts/MessageContext';
import Routing from '../../../routing/routing';

export const useListMenuData = () => {
  const { state } = useContext(MessageContext);

  const isMessagesLinkActive = useCallback((match: any, location: { pathname: string }) => {
    const { pathname } = location;
    return pathname?.startsWith(Routing.messages) || pathname?.startsWith(Routing.newMessage) || pathname?.startsWith(Routing.reply);
  }, []);

  return { isMessagesLinkActive, numberOfUnreadMessages: state.numberOfUnreadMessages };
};
